import { beforeVisitGlobalMember } from "../expressions/beforeVisitGlobalMember.js";
import { traverseStoryboardFunction } from "./traverse.js";
export function collectMemberUsageInFunction(fn, objectName, silentErrors) {
  let level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  const usage = {
    usedProperties: new Set(),
    hasNonStaticUsage: false
  };
  if (fn.source.includes(objectName)) {
    traverseStoryboardFunction(fn, beforeVisitGlobalMember(usage, objectName, level), silentErrors);
  }
  if (usage.hasNonStaticUsage && !silentErrors) {
    throw new Error(`Non-static usage of ${objectName} is prohibited, check your function: "${fn.name}"`);
  }
  usage.usedProperties.delete(fn.name);
  return usage.usedProperties;
}
//# sourceMappingURL=collectMemberUsageInFunction.js.map